import { Alert, Box, Button, Typography } from "@mui/material";
import { isEmpty, isNil } from "lodash";
import React from "react";
import { UseQueryResult } from "react-query";

import HarvestAPI from "../api/Harvest.api";
import PreliminaryWorkAPI from "../api/PreliminaryWork.api";

type Props = {
  harvestId: number;
  refetchHarvest: () => Promise<UseQueryResult>;
};

export default function PreliminaryWorkHarvestAttachedCheck({
  harvestId,
  refetchHarvest,
}: Props) {
  const { data: harvest } = HarvestAPI.useDetail({
    id: harvestId.toString(),
  });

  const { data: availablePreliminaryWork } =
    PreliminaryWorkAPI.useFetchAvailableByLot(harvest?.lotId);

  const { mutateAsync: mutateAttachPreliminaryWork } =
    PreliminaryWorkAPI.useAttachToHarvest({ harvestId });

  const { mutateAsync, isLoading } =
    PreliminaryWorkAPI.useCreateAndAttachHarvest({
      harvestId,
    });

  if (!harvest || isNil(harvest.lotable) || isEmpty(harvest.lotable)) {
    return <React.Fragment></React.Fragment>;
  }
  if (harvest.preliminaryWork) {
    return <React.Fragment></React.Fragment>;
  }

  const handleCreate = async () => {
    try {
      await mutateAsync();
      // TODO update Harvest also with the preliminary Work Id
    } catch (error) {
      console.error(error);
    }
  };

  const handleAttach = async () => {
    try {
      await mutateAttachPreliminaryWork({
        preliminaryWorkId: availablePreliminaryWork?.id,
        harvestId: harvest?.id,
      });
      await refetchHarvest();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Box>
      <Alert severity="warning">
        <Typography>
          Certain fields have been disabled as there no available associated
          preliminary work with the current Ranch/Lot attached to the Harvest.
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            gap: "1rem",
          }}
        >
          {harvest && harvest.lotId && !isNil(availablePreliminaryWork) && (
            <React.Fragment>
              <Button
                variant="contained"
                sx={{ marginTop: "1rem", marginBottom: "0.5rem" }}
                onClick={handleAttach}
                color={"secondary"}
              >
                Attach Latest Available Preliminary Work
              </Button>
            </React.Fragment>
          )}

          <Button
            variant="contained"
            sx={{ marginTop: "1rem", marginBottom: "0.5rem" }}
            onClick={handleCreate}
            disabled={isLoading}
          >
            Create Preliminary Work for Ranch / Lot
          </Button>
        </Box>
      </Alert>
    </Box>
  );
}
